import {
  SUBJECT_CODE_RUSSIAN,
  SUBJECT_CODE_MATH
} from '@/config'

export const subjectIds = [
  SUBJECT_CODE_RUSSIAN,
  SUBJECT_CODE_MATH
]

export const subjects = {
  [SUBJECT_CODE_RUSSIAN]: {
    cssClass: '_russian',
    bgIcons: ['rus-1', 'rus-2', 'rus-3', 'rus-4']
  },
  [SUBJECT_CODE_MATH]: {
    cssClass: '_math',
    bgIcons: ['math-1', 'math-2', 'math-3', 'math-4']
  }
}

export default function useSubjectsInfo () {
  return {
    subjectIds,
    subjects
  }
}
